/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_DeleteInputs */

const en_lesson_delete = /** @type {(inputs: Lesson_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete lesson`)
};

const he_lesson_delete = /** @type {(inputs: Lesson_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיקת שיעור`)
};

/**
* | output |
* | --- |
* | "Delete lesson" |
*
* @param {Lesson_DeleteInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_delete = /** @type {((inputs?: Lesson_DeleteInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_DeleteInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_delete(inputs)
	return he_lesson_delete(inputs)
});